import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-edit-profile',
  imports: [CommonModule],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.css'
})
export class EditProfileComponent {
  @Output() isEditModalOpen = new EventEmitter<boolean>();
  dropdownOpen = false;

  allRegions: string[] = [
    'Abruzzo', 'Basilicata', 'Calabria', 'Campania',
    'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio', 'Liguria',
    'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia',
    'Sardegna', 'Sicilia', 'Toscana', 'Provincia Autonoma di Trento',
    'Provincia Autonoma di Bolzano', 'Umbria', 'Valle d\'Aosta', 'Veneto'
  ];

  selectedRegions: string[] = [];

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  areAllSelected(): boolean {
    return this.selectedRegions.length === this.allRegions.length;
  }

  toggleAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedRegions = checked ? [...this.allRegions] : [];
  }

  toggleRegion(region: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      if (!this.selectedRegions.includes(region)) {
        this.selectedRegions.push(region);
      }
    } else {
      this.selectedRegions = this.selectedRegions.filter(r => r !== region);
    }
  }

  close(){
    this.isEditModalOpen.emit(false);
  }
}
